import React, { useState, useContext } from 'react';
import DepositCss from '../css/DepositCss';
import { useNavigate } from 'react-router-dom';
import { Context } from '../Context/Context';
import { Flip, toast } from 'react-toastify';
import { DeleteGamesApi } from '../Api/DeleteGames';
import { Helmet } from 'react-helmet';
export default function DeleteGame() {
    const [selectedGame, setSelectedGame] = useState('');

    const navigate = useNavigate();
    const { setLoad, setLoadColor, sessionDetail, setSessionDetail } = useContext(Context);

    const handleDelete = async () => {
        if (!selectedGame) {
            toast.error("Please select both client and game", {
                position: "top-right",
                autoClose: 1500,
                theme: "colored",
                transition: Flip,
            });
            return;
        }

        setLoad(true);
        setLoadColor("#ff4d4d");

        const requestData = {
            username: JSON.parse(localStorage.getItem('userinfo'))?.username,
            game_name: selectedGame,
            user_id: JSON.parse(localStorage.getItem('userinfo'))?.userId
        };

        try {
            console.log("Deleting Jantri Games for:", requestData);
            const res = await DeleteGamesApi(requestData);
            if (res.data.status) {
                setSessionDetail(prev => ({
                    ...prev,
                    user_games: res.data.data.user_games
                }));

                toast.success("Jantri Games deleted successfully!", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                    transition: Flip,
                });

                navigate("/game");
            } else {
                toast.error(res.data.message, {
                    position: "top-right",
                    autoClose: 2000,
                    theme: "colored",
                    transition: Flip,
                });
            }
        } catch (error) {
            toast.error("Failed to delete Jantri", {
                position: "top-right",
                autoClose: 2000,
                theme: "colored",
                transition: Flip,
            });
        } finally {
            setLoad(false);
        }
    };

    return (
        <DepositCss>
            <Helmet>
                {/* Page Title */}
                <title>Delete Jantri | Clear Bets for Client & Bazar | Matka Jantri</title>

                {/* SEO Description */}
                <meta
                    name="description"
                    content="This page allows clearing Jantri bets for a specific client and bazar quickly and efficiently on MatkaJantri."
                />

                {/* SEO Directives */}
                <meta name="robots" content="noindex, nofollow" />

                {/* Canonical URL */}
                <link rel="canonical" href="https://pushpabetfair.com/delete-jantri" />

                {/* Favicon and Icons */}
                <link rel="icon" href="/favicon.ico" type="image/x-icon" />
                <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
                <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
                <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />

                {/* Mobile Optimization */}
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />

                {/* Open Graph */}
                <meta property="og:title" content="Delete Jantri | Clear Bets for Client & Bazar | MatkaJantri" />
                <meta
                    property="og:description"
                    content="This page allows clearing Jantri bets for a specific client and bazar quickly and efficiently on MatkaJantri."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://pushpabetfair.com/delete-jantri" />
                <meta property="og:image" content="https://app.matkajantri.com/JantriImage/Logo.png" />
            </Helmet>

            <div className="w-100 fullpage">
                <div className="w-3">
                    <div className="back-top">
                        <i className="fa-solid fa-chevron-left" onClick={() => navigate("/game")}></i>
                    </div>
                    <div className="w-100 text-center d-flex">
                        <button className="addFunds">
                            <i className="fa-solid fa-trash"></i> Delete Games
                        </button>
                    </div>

                    <div className="w-100 px-3">

                        {/* Select Game */}
                        <div className="mb-3 w-100">
                            <label className="form-label">Select Game <span style={{ color: 'red' }}>*</span></label>
                            <select
                                className="form-control"
                                value={selectedGame}
                                onChange={(e) => setSelectedGame(e.target.value)}
                            >
                                <option value="">-- Select Game --</option>
                                {sessionDetail?.user_games?.map((games, index) => (
                                    <option key={index} value={games}>{games}</option>
                                ))}
                            </select>
                        </div>

                        <div className="text-center">
                            <button className="submit-btn support-btn" onClick={handleDelete}>
                                Delete Games
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </DepositCss>
    );
}
